module.exports = __webpack_public_path__ + "img/face24.788856d9.jpg";